import { _ as _$1 } from '@swc/helpers/esm/_object_spread.js';
import { _ } from '@swc/helpers/esm/_object_spread_props.js';
import connectConfigureRelatedItems from '../../connectors/configure-related-items/connectConfigureRelatedItems.js';
import { noop } from '../../lib/utils/noop.js';

var configureRelatedItems = function configureRelatedItems(widgetParams) {
    var makeWidget = connectConfigureRelatedItems(noop);
    return _(_$1({}, makeWidget(widgetParams)), {
        $$widgetType: 'ais.configureRelatedItems'
    });
};

export { configureRelatedItems as default };
